import { useState } from "react";
import SectionHeading from "../components/SectionHeading";
import { testimonials } from "../data/testimonials";
import "./ParentSpeak.css";

export default function ParentSpeak() {
  const [index, setIndex] = useState(0);
  const total = testimonials.length;

  const go = (step) => {
    setIndex((i) => (i + step + total) % total);
  };

  return (
    <section id="testimonials" className="section section--pink reviews-section">
      <div className="container">
        <SectionHeading plain="Parents" accent="Speak">
          Read what parents love about our play school and how it positively
          impacts their children's growth!
        </SectionHeading>

        <div className="reviews">
          <button
            type="button"
            className="reviews__arrow"
            onClick={() => go(-1)}
            aria-label="Previous review"
          >
            <img src="/images/left.png" alt="" />
          </button>

          <div className="reviews__stack" aria-live="polite">
            {testimonials.map(({ name, review, reviewLink }, i) => (
              <article
                key={name}
                className={`review${i === index ? " is-active" : ""}`}
                aria-hidden={i !== index}
              >
                <img
                  className="review__avatar"
                  src="/profile pictures/blank-pfp.webp"
                  alt=""
                />

                <div className="review__card">
                  <h3>{name}</h3>

                  <img
                    className="review__stars"
                    src="/images/stars.png"
                    alt="5 out of 5 stars"
                  />

                  <p className="review__text">{review}</p>
                </div>

                <a
                  className="btn review__link"
                  href={reviewLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  tabIndex={i === index ? 0 : -1}
                >
                  Read on Google
                </a>
              </article>
            ))}
          </div>

          <button
            type="button"
            className="reviews__arrow"
            onClick={() => go(1)}
            aria-label="Next review"
          >
            <img src="/images/right.png" alt="" />
          </button>
        </div>

        <p className="reviews__count">
          {index + 1} / {total}
        </p>
      </div>
    </section>
  );
}